import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDeleteMilestone = createAsyncThunk("fetchDeleteMilestone", async ({ id }, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const response = await axiosHttp.get(`milestone/delete/${id}`, config);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const deleteMilestoneSlice = createSlice({
	name: "deleteMilestoneSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
	},

	reducers: {
		resetDeleteMilestoneState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDeleteMilestone.pending, (state, action) => {
			state.isError = false;
			state.isLoading = true;
		});

		builder.addCase(fetchDeleteMilestone.fulfilled, (state, action) => {
			state.isError = false;
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchDeleteMilestone.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetDeleteMilestoneState } = deleteMilestoneSlice.actions;
export default deleteMilestoneSlice.reducer;
